module.exports = __webpack_public_path__ + "img/About-us.0d4de21d.png";